import { render, staticRenderFns } from "./todosProcesos.vue?vue&type=template&id=4ba94f18&scoped=true"
import script from "./todosProcesos.vue?vue&type=script&lang=js"
export * from "./todosProcesos.vue?vue&type=script&lang=js"
import style0 from "./todosProcesos.vue?vue&type=style&index=0&id=4ba94f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba94f18",
  null
  
)

export default component.exports